var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",attrs:{"action":_vm.oauth2Endpoint,"method":"get"}})}
var staticRenderFns = []

export { render, staticRenderFns }